import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import { useState } from "react";

import FileItemView from "@/common/components/Files/FileItemView";
import { FileItem } from "@/common/fileItem";
import { ArrayHelper } from "@/common/helpers/array";

import NoDataAlert from "../../AppAlerts/NoDataAlert";
import FullScreenFileViewerV2 from "../FullScreenFileViewerV2";

export interface ImageThumbnailListProps {
  images: FileItem[];
  selectedId?: string;
  onSelect: (file: FileItem) => void;
}

export function ImageComparisonThumbnailList({
  images,
  selectedId,
  onSelect,
}: ImageThumbnailListProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [quickViewFile, setQuickViewFile] = useState<FileItem | undefined>(undefined);

  return (
    <Stack
      direction='row'
      gap={1}
      sx={{
        flexWrap: { xxs: "nowrap", md: "wrap" },
        maxWidth: "100%",
        maxHeight: "100%",
        overflowX: "auto",
        overflowY: "auto",
      }}
    >
      {ArrayHelper.isEmpty(images) && <NoDataAlert title='No images.' />}

      {images.map((imageItem) => {
        const isSelected = imageItem.id === selectedId;

        return (
          <Box
            key={imageItem.id}
            sx={
              {
                // borderRadius: 1,
                // outline: isSelected ? "2px solid" : "1px solid",
                // outlineColor: (t) => (isSelected ? t.palette.primary.main : t.palette.divider),
                // p: 0.25,
                // backgroundColor: (theme) => theme.palette.background.gray,
                // borderWidth: 2,
                // borderStyle: "solid",
                // borderColor: (theme) => (isSelected ? theme.palette.secondary.main : "transparent"),
                // borderRadius: (theme) => theme.shapeCustom.borderRadiusCard,
                // cursor: "pointer",
              }
            }
          >
            <FileItemView
              sx={{
                // width: ,
                // height: "100px",
                // width: "unset",
                // aspectRatio: "1/1",
                // objectFit: "contain",
                backgroundColor: (th) => th.palette.background.gray,
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: (th) => (isSelected ? th.palette.secondary.main : "transparent"),
                borderRadius: (th) => th.shapeCustom.borderRadiusCard,
                cursor: "pointer",
              }}
              // imageSx={{ objectFit: "contain" }}
              size={isMobile ? { width: 60, height: 60 } : { width: 100, height: 100 }}
              fileItem={imageItem}
              actions={{
                enabled: true,
                click: true,
                quickView: true,
                onClick: () => {
                  onSelect(imageItem);
                },
                onQuickView: (f) => {
                  setQuickViewFile(f);
                },
              }}
              useThumbnail
              withCaption={false}
              showAIInsightsTags
            />
          </Box>
        );
      })}

      {quickViewFile && (
        <FullScreenFileViewerV2
          files={[quickViewFile]}
          selectedFileId={quickViewFile.id}
          onClose={() => {
            setQuickViewFile(undefined);
          }}
        />
      )}
    </Stack>
  );
}
